import fivestar from '../assets/fivestar.png';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import { HashLink } from 'react-router-hash-link';

function Section5() {
  return (
    <div className="pb-10 md:pb-20 text-black bg-gray-100 relative">
      <div className="hidden lg:block absolute right-0 top-0">
        <div className="bg-blue-600 h-[40rem] w-[30rem] z-0 rounded-l-full"></div>
      </div>
      <div>
        <p className="font-bold text-4xl md:text-5xl text-center pt-10 mb-3">
          Our <span className="text-blue-600">Reviews</span>
        </p>
        <hr className="border-1 border-[#0098D1] w-20 mx-auto rounded-md" />
      </div>
      <div className="flex flex-col lg:flex-row w-full h-[950px] lg:h-[350px] mt-8 lg:mt-14">
        <div className="bg-white rounded-xl w-[350px] lg:w-[350px] mx-auto lg:ml-32 2xl:ml-80 p-5 shadow-[#0098D1] shadow-md overflow-auto">
          <p className="font-medium text-xl mb-5">Jonathan Q.</p>
          <img src={fivestar} alt="five stars" className="w-28 h-5 mb-5" />
          <p className="text-gray-500 text-sm">
            "Absolutely outstanding service from start to finish! I recently had
            a new AC unit installed by Robert, and I couldn’t be happier with
            the experience. From the initial consultation to the final
            installation, the entire team was professional, knowledgeable, and
            incredibly efficient. They gave me a clear and fair quote, explained
            my options without pressure, and scheduled the work quickly. 10/10
            experience"
          </p>
        </div>
        <div className="bg-white rounded-xl w-[350px] lg:w-[350px] mx-auto lg:mx-8 p-5 mt-8 lg:mt-0 shadow-[#0098D1] shadow-md overflow-auto z-10">
          <p className="font-medium text-xl mb-5">Gabriel G.</p>
          <img src={fivestar} alt="five stars" className="w-28 h-5 mb-5" />
          <p className="text-gray-500 text-sm">
            "Absolutely outstanding service from start to finish! I recently had
            a new AC unit installed by Robert, and I couldn’t be happier with
            the experience. From the initial consultation to the final
            installation, the entire team was professional, knowledgeable, and
            incredibly efficient. They gave me a clear and fair quote, explained
            my options without pressure, and scheduled the work quickly. 10/10
            experience"
          </p>
        </div>
        <div className="bg-white rounded-xl w-[350px] lg:w-[350px] mx-auto lg:mr-32 2xl:mr-80 z-10 p-5 mt-8 lg:mt-0 shadow-[#0098D1] shadow-md overflow-auto">
          <p className="font-medium text-xl mb-5">Arben P.</p>
          <img src={fivestar} alt="five stars" className="w-28 h-5 mb-5" />
          <p className="text-gray-500 text-sm">
            "I had an excellent experience with Mr. Freeze Cooling & Heating
            From start to finish, their team was professional, knowledgeable,
            and very respectful of my home and at my Business as well. They
            arrived on time, explained everything clearly, and completed the job
            quickly and efficiently. My system is running better than ever, and
            I can already feel the difference in comfort and energy efficiency."
          </p>
        </div>
      </div>
      <div className="flex justify-center mt-10">
        <HashLink
          to="/#Contact"
          className="bg-[#0098D1] rounded-sm text-white px-6 py-3 shadow-black shadow-sm hover:bg-blue-600"
        >
          Get In Touch
        </HashLink>
      </div>
    </div>
  );
}

export default Section5;
